import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { StylesProvider } from "@material-ui/styles";
import themes from "devextreme/ui/themes";

themes.initialized(() =>
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <StylesProvider injectFirst>
          <Router>
            <App />
          </Router>
        </StylesProvider>
      </Provider>
    </React.StrictMode>,
    document.getElementById("app")
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
